import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    tokenExpire: null,
    tagsStoreList: [],
    // language: Cookies.get('language') || 'zh',
    //   language: 'zh',
    roleNames: [],
    organization_id: ""
  },
  mutations: {
    saveToken(state, data) {
      console.log(state, data);
      state.token = data;
      console.log(state);
      window.localStorage.setItem("token", data);
    },
    saveTokenExpire(state, data) {
      state.tokenExpire = data;
      window.localStorage.setItem("TokenExpire", data);
    },
    saveTagsData(state, data) {
      state.tagsStoreList = data;
      sessionStorage.setItem("Tags", data);
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      // Cookies.set('language', language)
    }
  },
  actions: {
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js